import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';

const fillSubActivitiesForm = async (activityConfigId, subActivitiesBodyForm) => {
  if (!activityConfigId) return;

  const guestActivityDomesticData = subActivitiesBodyForm.querySelector('.guest-activity-domestic-data').dataset;
  const subActivitiesConfigDiv = subActivitiesBodyForm.querySelector('.sub-activities-config-div');
  // 'input#from_planner, input#repeats_end_on, input#activity_planned_date'
  const gadPrevInput = subActivitiesBodyForm.querySelector('input#activity_planned_date');
  const gadDoneInput = subActivitiesBodyForm.querySelector('input#modal-for-agenda-data-inizio');
  const gapFromInput = subActivitiesBodyForm.querySelector('input#from_planner');
  const gapToInput = subActivitiesBodyForm.querySelector('input#repeats_end_on');

  let startDate, endDate;

  if (!!gadDoneInput || !!gadPrevInput) {
    startDate = endDate = gadDoneInput.value || gadPrevInput.value;
  }
  if (!!gapFromInput && !!gapToInput) {
    startDate = gapFromInput.value;
    endDate = gapToInput.value;
  }

  const multi_activity_in_plan = subActivitiesConfigDiv.dataset.multiActivityInPlan != null;
  const attribute_name = subActivitiesConfigDiv.dataset.attributeName;
  const can_edit = subActivitiesConfigDiv.dataset.canEditDone != null;
  const can_plan = subActivitiesConfigDiv.dataset.canPlan != null;
  const guestActivityDomesticsId = guestActivityDomesticData.guestActivityDomesticId;
  const spotActivity = document.querySelector('#input_spot_activity');
  const checkedSubs = ($(subActivitiesConfigDiv).data(`checkedSubs`) || '').split(',');

  try {
    const url = `/${window.locale}/activities_configs/get_sub_activities_configs.json`;
    const params = new URLSearchParams({ activity_config_id: activityConfigId });
    if (guestActivityDomesticsId) {
      params.append('guest_activity_domestics_id', guestActivityDomesticsId);
    }
    if (startDate) {
      params.append('start_date', startDate);
    }
    if (endDate) {
      params.append('end_date', endDate);
    }
    const response = await apiConnector().get(`${url}?${params.toString()}`);
    const data = response.data;
    if (!data.results?.length) {
      const targetDiv = subActivitiesBodyForm.querySelector('.sub-activities-config-div');
      if (targetDiv) targetDiv.innerHTML = '';
      return;
    }

    let subactivities = data.results;

    try {
      const smartleaSubActivities = JSON.parse(subActivitiesConfigDiv.dataset.smartleaSubActivities);

      if (Array.isArray(smartleaSubActivities) && smartleaSubActivities.length > 0) {
        subactivities = subactivities.filter((sub) => smartleaSubActivities.includes(sub.text));
      }
    } catch (e) {
      console.log('data smartlea non è un json valido');
    }

    let filteredSubactivities = [];
    if (multi_activity_in_plan && guestActivityDomesticData.guestActivityDomesticId) {
      filteredSubactivities = subactivities.filter(
        (sub_activity) => subActivitiesConfigDiv.dataset[`subactivities-${sub_activity.id}`] != null,
      );
    }

    if (filteredSubactivities?.length) {
      subactivities = filteredSubactivities;
    }

    const htmlSubactivities = subactivities.map((sub_activity) => {
      const isChecked =
        sub_activity.status === true || sub_activity.status === 'true' || checkedSubs.includes(`${sub_activity.id}`)
          ? 'checked="checked"'
          : '';
      return `
          <li>
          <label class="checkbox">
            <input type="hidden" name="${attribute_name}[sub_activities][${sub_activity.id}]"
              class="js-checkbox-sub-activities" value="false">
            <input type="checkbox" name="${attribute_name}[sub_activities][${sub_activity.id}]"
              class="js-checkbox-sub-activities" value="true" ${isChecked}>
            ${sub_activity.text}
          </label>
          </li>
        `;
    });

    const container = subActivitiesBodyForm.querySelector('.sub-activities-config-div');
    if (container) {
      let searchInput = '';
      if (subactivities.length > 10) {
        searchInput = `<label class="control-label"></label>
          <div class="controls"><input type='text' placeholder='cerca sotto-attività' class='js-subactivities-find' /></div>`;
      }
      container.innerHTML = `
          ${searchInput}
          <label class="control-label sub-activities-config-label" for="${attribute_name}_">${i18nJS.sub_activities.label}</label>
          <div style="max-height: 200px; overflow-y: auto" class="controls sub-activities-config-list">
            <ul class='ul-subactivities'>${htmlSubactivities.join('')}</ul>
          </div>
        `;
    }

    const checkboxes = subActivitiesBodyForm.querySelectorAll('.js-checkbox-sub-activities');

    if (!spotActivity || spotActivity.value === 'false') {
      const done = guestActivityDomesticData.done == 'true';
      const hasId = guestActivityDomesticData.guestActivityDomesticId;

      if (!multi_activity_in_plan && !done && !hasId) {
        checkboxes.forEach((cb) => {
          cb.classList.add('hide');
          cb.disabled = true;
        });
      }

      if (!done && hasId && !can_plan) {
        checkboxes.forEach((cb) => (cb.disabled = true));
      }

      if (done && !can_edit) {
        checkboxes.forEach((cb) => (cb.disabled = true));
      }
    }
    if (subactivities.length > 10) {
      window.UlFilter.init(container.querySelector('.js-subactivities-find'), container.querySelector('.ul-subactivities'));
    }
  } catch (e) {
    console.error('qualcosa non ha funzionato nel recupero delle sotto-attività', e);
    errorManager(e);
  }
};

function init(select2_element_class) {
  try {
    const select2_element = document.querySelector(select2_element_class);
    const modal_body = select2_element.closest('.modal-body');
    $(modal_body).data('activitySelector', select2_element_class);

    $(select2_element_class).on('select2:unselect', (e) => {
      e.target.closest('.modal-body').querySelector('.sub-activities-config-div').innerHTML = '';
    });

    if (select2_element.value) {
      const subActivitiesBodyForm = select2_element.closest('.modal-body');
      fillSubActivitiesForm(select2_element.value, subActivitiesBodyForm);
    }
    $(select2_element_class).on('change', (e) => {
      const subActivitiesBodyForm = e.target.closest('.modal-body');
      fillSubActivitiesForm(e.target.value, subActivitiesBodyForm);
    });

    $(modal_body).on(
      'change',
      'input#from_planner, input#repeats_end_on, input#activity_planned_date, input#modal-for-agenda-data-inizio',
      (e) => {
        const activitySelect = modal_body.querySelector($(modal_body).data('activitySelector'));
        fillSubActivitiesForm(activitySelect.value, modal_body);
      },
    );

    $(modal_body).on('change', 'input.js-checkbox-sub-activities', (e) => {
      const subBody = e.target.closest('.sub-activities-config-div');
      const regex = /\[(\d+)\]$/;
      const match = e.target.name.match(regex);
      let checkedSubs = ($(subBody).data(`checkedSubs`) || '').split(',');
      const isCurrentChecked = $(e.target).prop('checked');

      if (match && match[1]) {
        const subId = match[1];

        if (isCurrentChecked) {
          checkedSubs.push(subId);
        } else {
          const index = checkedSubs.indexOf(subId);
          if (index > -1) checkedSubs.splice(index, 1);
        }

        $(subBody).data(`checkedSubs`, checkedSubs.toString());
      }
    });
  } catch (e) {
    errorManager(e);
  }
}

window.SubActivitiesConfig = {
  init: init,
};
